import { UserGroups } from '@/modules/Permissions';

export const routes = {
  home: '/',
  login: '/login',
  logout: '/logout',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  otp_setup: '/otp-setup',
  onboarding: '/onboarding',
  customerProjectsList: '/customers/:customerId/projects',
  customerProjectFarmsList: '/customers/:customerId/projects/:projectId/farms',
  customerProjectDetails: '/customers/:customerId/projects/:projectId',
  customerProjectFarmDetails: '/customers/:customerId/projects/:projectId/farms/:farmId',
  customerProjectFarmFieldDetails: '/customers/:customerId/projects/:projectId/farms/:farmId/fields/:fieldId',
  editCustomer: '/customers/edit/:customerId',
  editProject: '/projects/edit/:projectId',
  customers: '/customers',
  projects: '/projects',
  farms: '/farm-list',
  users: '/user-list',
  addUser: '/users/add',
  editUser: '/users/edit/:userId',
  profile: '/profile',
  settings: '/settings',
} as const;
export type Route = (typeof routes)[keyof typeof routes];

export const userGroupIndexMap = {
  [UserGroups.AGRI_ADMIN]: routes.customers,
  [UserGroups.AGRI_QA]: routes.customers,
  [UserGroups.AGRI_PM]: routes.projects,
  [UserGroups.CLIENT_ADMIN]: routes.projects,
  [UserGroups.PROJECT_MANAGER]: routes.projects,
  [UserGroups.FARMER]: routes.farms,
} as const;
